import styled from 'styled-components';

export const StyledBrandsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4rem 6rem;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 10rem;
  margin-top: 4.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 4rem 2rem;
  }
`;

export const Logo = styled.img`
  max-width: 18rem;
  max-height: 4.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 14rem;
    max-height: 4rem;
  }
`;
